module.exports = __webpack_public_path__ + "pc-static/img/oks.ab66355.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/oks.png
// module id = VyqP
// module chunks = 1